<template>
  <v-row class="pa-1">
    <v-chip-group
      v-model="orderNav"
      column
      style="position: -webkit-sticky; position: sticky; z-index: 1"
      class="mx-2 pa-1"
      v-if="orders != null && orders.length > 0"
    >
      <v-chip small color="primary" filter>
        {{ stringValues.allOrders[currentLanguage.language] }} ({{
          orders.length
        }})
      </v-chip>
      <v-chip
        small
        color="primary"
        filter
        v-for="order in orders"
        :key="order.id"
      >
        <code>{{ order.id }}</code>
        {{ order.filial.name }}
      </v-chip>
    </v-chip-group>

    <v-col cols="12">
      <v-row no-gutters v-if="orders != null && orders.length > 0">
        <v-col cols="6">
          <v-btn
            class="mb-1"
            color="primary"
            small
            outlined
            @click="collapseAllOrders()"
          >
            <v-icon>mdi-chevron-down</v-icon>
            <span>Свернуть все заказы</span>
          </v-btn>
          <v-btn
            class="mb-1 ml-1"
            color="primary"
            small
            outlined
            @click="expandAllOrders()"
          >
            <v-icon>mdi-chevron-up</v-icon>
            <span>Развернуть все заказы</span>
          </v-btn>
        </v-col>
        <v-col cols="4" class="text-right">
          <v-btn class="mb-1" color="primary" small outlined>
            <span class="black--text">Общая сумма заказов со скидкой:</span>
            <span class="primary--text font-weight-bold ml-1">
              {{ ordersTotalSum | toDecimal }}
            </span>
          </v-btn>
        </v-col>
        <v-col cols="2" class="text-right">
          <div class="mb-1">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  color="error"
                  small
                  @click="openDeleteDialog(
                    'Удаление заказов',
                    'Вы действительно хотите удалить все заказы пользователя?',
                    DeleteOrderByUser
                  )"
                  :loading="loading.deleteOrderByUser"
                  :disabled="loading.deleteOrderByUser"
                >
                  <v-icon left>mdi-delete</v-icon>
                  Удалить все заказы
                </v-btn>
              </template>
              <span>{{
                stringValues.deleteOrderByUser[currentLanguage.language]
              }}</span>
            </v-tooltip>
          </div>
        </v-col>
      </v-row>
      <!-- orders -->
      <v-card
        class="mb-5"
        v-for="item in ordersNav"
        :key="item.id"
        :id="`order${item.id}`"
        elevation="5"
        tile
      >
        <!-- header -->
        <v-row no-gutters class="pt-2 primary">
          <v-col cols="12">
            <v-row>
              <v-col cols="9" class="text-truncate">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-btn text fab @click="collapseOrder(item.id)">
                      <v-icon
                        color="white"
                        v-if="collapsedOrders.includes(item.id)"
                      >
                        mdi-chevron-down
                      </v-icon>
                      <v-icon color="white" v-else> mdi-chevron-up </v-icon>
                    </v-btn>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-subtitle class="white--text text-caption">
                      {{ stringValues.orderNumber[currentLanguage.language] }}:
                      <code class="caption font-weight-bold">{{
                        item.id
                      }}</code>
                      {{ stringValues.goods[currentLanguage.language] }}:
                      <code class="caption font-weight-bold">{{
                        item.orderDetails.length
                      }}</code>
                      {{ stringValues.dateCreate[currentLanguage.language] }}:
                      <code class="caption font-weight-bold">
                        {{
                          new Date(item.createdDate).toLocaleString([], {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        }}
                      </code>
                      {{ stringValues.paymentType[currentLanguage.language] }}:
                      <code class="caption font-weight-bold">
                        {{
                          paymentTypes.find(
                            (x) => x.id == item.orderDetails[0].paymentType
                          ) != null
                            ? paymentTypes.find(
                                (x) => x.id == item.orderDetails[0].paymentType
                              ).type
                            : ""
                        }}
                      </code>
                    </v-list-item-subtitle>
                    <v-list-item-title class="white--text text-subtitle-2">{{
                      item.filial.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3" class="text-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-2 my-2"
                      fab
                      small
                      v-on="on"
                      @click="
                        currentOrder = item;
                        dialog.orderFullScreen = true;
                      "
                    >
                      <v-icon>mdi-fullscreen</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    stringValues.seeInFullScreen[currentLanguage.language]
                  }}</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      class="mx-2 my-2"
                      fab
                      small
                      v-on="on"
                      @click="
                        currentOrder = item;
                        dialog.shareOnChat = true;
                      "
                    >
                      <v-icon>mdi-share-variant</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    stringValues.shareInChat[currentLanguage.language]
                  }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- body -->
        <v-row v-if="!collapsedOrders.includes(item.id)">
          <!-- details operation -->
          <v-col cols="1" class="text-right">
            <v-card
              elevation="0"
              style="position: -webkit-sticky; position: sticky; top: 60px"
              class="pt-4"
            >
              <div class="mb-1">
                <v-menu top offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on: onMenu }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on: onTooltip }">
                        <v-btn v-on="{ ...onTooltip, ...onMenu }" fab x-small>
                          <v-icon>mdi-content-cut</v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        stringValues.movedInStore[currentLanguage.language]
                      }}</span>
                    </v-tooltip>
                  </template>
                  <v-list dense max-width="230px">
                    <v-subheader v-if="storages.length == 0"
                      >У вас нет активных хранилище</v-subheader
                    >
                    <template v-for="(accessStorage, index) in storages">
                      <v-divider :key="index" v-if="index !== 0"></v-divider>
                      <v-list-item :key="-index" @click="0">
                        <v-list-item-content
                          @click="
                            MoveDetailsToStorage(
                              item.selectedDetails,
                              accessStorage.storage.id
                            )
                          "
                        >
                          <code class="subtitle-2">{{
                            accessStorage.storage.name
                          }}</code>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </div>
              <div class="mb-1">
                <v-menu top offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on: onMenu }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on: onTooltip }">
                        <v-btn v-on="{ ...onTooltip, ...onMenu }" fab x-small>
                          <v-icon>mdi-box-cutter</v-icon>
                        </v-btn>
                      </template>
                      <span>{{
                        stringValues.moveToOrdersSupplier[
                          currentLanguage.language
                        ]
                      }}</span>
                    </v-tooltip>
                  </template>
                  <v-list dense two-line max-width="200px">
                    <template
                      v-if="
                        orders.filter(
                          (x) => x.filialId == item.filialId && x.id !== item.id
                        ).length < 1
                      "
                    >
                      <v-subheader>Нет других заказов у поставщика</v-subheader>
                    </template>
                    <template
                      v-for="(orderItem, index) in orders.filter(
                        (x) => x.filialId == item.filialId && x.id !== item.id
                      )"
                    >
                      <v-divider :key="index" v-if="index !== 0"></v-divider>
                      <v-list-item :key="-index" @click="0">
                        <v-list-item-content
                          @click="
                            MoveDetailsToOrder(
                              item.selectedDetails,
                              orderItem.id
                            )
                          "
                        >
                          <v-list-item-title>
                            К заказу
                            <code class="subtitle-2">{{ orderItem.id }}</code>
                          </v-list-item-title>
                          <v-list-item-subtitle
                            v-html="orderItem.createdDate"
                          ></v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-menu>
              </div>
              <div class="mb-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      @click="SplitDetails(item.selectedDetails)"
                    >
                      <v-icon>mdi-call-split</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    stringValues.splitOrder[currentLanguage.language]
                  }}</span>
                </v-tooltip>
              </div>
              <div class="mb-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      x-small
                      @click="openDeleteDialog(
                        'Удаление позиций',
                        'Вы действительно хотите удалить выбранные позиции?',
                        DeleteDetails,
                        item.selectedDetails
                    )"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    stringValues.deletePosition[currentLanguage.language]
                  }}</span>
                </v-tooltip>
              </div>
            </v-card>
          </v-col>

          <!-- details -->
          <v-col cols="10">
            <v-data-table
              filterable
              v-model="item.selectedDetails"
              :headers="headers[currentLanguage.language]"
              :items="item.orderDetails"
              dense
              show-select
              item-key="id"
              :items-per-page="100"
              disable-pagination
              hide-default-footer
              class="orderList"
              :item-class="getRowClass"
            >
              <template v-slot:item.id="{ item }">
                <v-chip>
                  {{
                    item.orderDetails
                      .map(function (x) {
                        return x.id;
                      })
                      .indexOf(item.id) + 1
                  }}
                </v-chip>
              </template>

              <template v-slot:item.index="{ index}">
                <b>{{ index + 1 }}.</b>
              </template>

              <!-- TODO переписать  -->
              <template v-slot:item.quantity="props">
                <span style="float: left;">
                  <b>{{ props.item.quantity }}</b>
                </span>
                <v-edit-dialog
                  :return-value.sync="props.item.quantity"
                  large
                  lazy
                  persistent
                  @save="SaveQuantity(props.item)"
                  @cancel="CancelQuantity"
                  @open="OpenQuantity"
                  @close="CloseQuantity"
                  :saveText="stringValues.save[currentLanguage.language]"
                  :cancelText="stringValues.cancel[currentLanguage.language]"
                  v-if="
                    props.item.isMainWorkloadGroup != false ||
                    props.item.isMainPromoGroup != false
                  "
                >
                  <div class="text-no-wrap">
                    <v-icon small>mdi-pencil</v-icon>
                  </div>
                  <v-badge
                    v-if="props.item.quantityChanged"
                    color="warning"
                    bordered
                    :content="`${props.item.oldQuantity}`"
                  ></v-badge>
                  <template v-slot:input>
                    <v-text-field
                      v-model="props.item.quantity"
                      single-line
                      counter
                      autofocus
                      type="number"
                      :rules="[quantityRules]"
                      label="Введите количество"
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </template>

              <template v-slot:item.priceWithDiscount="{ item }">
                <div class="text-no-wrap">
                  <span
                    v-bind:style="[IsMinPrice(item) ? {} : { color: 'red' }]"
                  >
                    {{
                      (item.price *
                        (1 - (item.discount + item.discountPayment) / 100))
                        | toDecimal
                    }}
                  </span>
                  <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        small
                        v-on="on"
                        @click="GetPriceByGoodsIdAndCityId(item)"
                        >mdi-redo</v-icon
                      >
                    </template>
                    <v-simple-table fixed-header max-height="300px" dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{
                                stringValues.provider[currentLanguage.language]
                              }}
                            </th>
                            <th class="text-left">
                              {{ stringValues.price[currentLanguage.language] }}
                            </th>
                            <th class="text-left">
                              {{
                                stringValues.expireDate[
                                  currentLanguage.language
                                ]
                              }}
                            </th>
                            <th class="text-left">
                              {{
                                stringValues.remains[currentLanguage.language]
                              }}
                            </th>
                          </tr>
                        </thead>
                        <tbody v-if="goodsPrices.length">
                          <tr
                            v-for="price in goodsPrices"
                            :key="price.id"
                            @click="SelectFilial(price, item)"
                          >
                            <td>
                              {{ price.filial.name }}
                              <code v-if="price.userDiscount !== 0"
                                >{{ price.userDiscount }}%</code
                              >
                              <v-spacer></v-spacer>
                              <code v-if="price.isntDiscount">без скидки</code>
                              <v-tooltip top v-if="price.isPromotion">
                                <template v-slot:activator="{ on }">
                                  <code v-on="on">акция</code>
                                </template>
                                <span> {{ price.promotionDescription }}</span>
                              </v-tooltip>
                            </td>

                            <td>
                              <code v-if="price.userDiscount !== 0">{{
                                (price.goodsPrice -
                                  (price.userDiscount * price.goodsPrice) / 100)
                                  | toDecimal
                              }}</code>
                              {{ price.goodsPrice | toDecimal }}
                            </td>
                            <td>
                              <span>{{
                                price.shelfLife.substr(0, 10) | toDate
                              }}</span>
                            </td>
                            <td>
                              <span v-if="price.stored > 0">{{
                                price.stored
                              }}</span>
                              <span v-else>{{
                                stringValues.nd[currentLanguage.language]
                              }}</span>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="4">Нет прайсов</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-menu>
                </div>
              </template>

              <template v-slot:item.price="{ item }">
                <div class="text-no-wrap">
                  {{ item.price | toDecimal }}
                </div>
                <v-badge
                  v-if="item.priceChanged"
                  color="warning"
                  bordered
                  :content="`${item.oldPrice}`"
                ></v-badge>
              </template>

              <template v-slot:item.goods.priceLimitation.retail="{ item }">
                <span 
                  v-if="item.goods.priceLimitation != null"
                  :class="{
                    'red--text': item.price > item.goods.priceLimitation.retail
                  }"
                  >{{
                  item.goods.priceLimitation.retail | toDecimal
                }}</span>
                <code v-else>{{
                  stringValues.nd[currentLanguage.language]
                }}</code>
              </template>

              <template v-slot:item.goods.priceLimitation.trade="{ item }">
                <span 
                  v-if="item.goods.priceLimitation != null"
                  :class="{
                    'red--text': item.price > item.goods.priceLimitation.trade
                  }"
                  >{{
                  item.goods.priceLimitation.trade | toDecimal
                }}</span>
                <code v-else>{{
                  stringValues.nd[currentLanguage.language]
                }}</code>
              </template>

              <template v-slot:item.goods.fullName="{ item }">
                <b>{{ item.goods.name.name }}</b>
                <v-subheader class="custom-subheader">
                  {{ item.goods.producer.name }}
                </v-subheader>
                <v-chip
                  v-if="item.isMarked"
                  x-small
                  style="
                    background-color: #fff6bd;
                    color: #d50f0a;
                    border: 1px solid #fad28f;
                  "
                  >
                  <v-icon>mdi-qrcode</v-icon>
                    Маркирован
                </v-chip>
                <v-chip
                  v-if="
                    item.promoGroup != null && item.isMainPromoGroup == true
                  "
                  color="#6DBFB9"
                  dark
                  x-small
                  >A</v-chip
                >
                <v-chip
                  v-if="
                    item.promoGroup != null && item.isMainPromoGroup == false
                  "
                  color="teal"
                  dark
                  x-small
                  >G</v-chip
                >

                <v-chip
                  v-if="
                    item.workloadGroup != null &&
                    item.isMainWorkloadGroup == true
                  "
                  color="#559EBF"
                  dark
                  x-small
                  >L</v-chip
                >

                <v-chip
                  v-if="
                    item.workloadGroup != null &&
                    item.isMainWorkloadGroup == false
                  "
                  color="#2B5666"
                  dark
                  x-small
                  >W</v-chip
                >
              </template>

              <template v-slot:item.shelfLife="{ item }">{{
                item.shelfLife.substr(0, 10) | toDate
              }}</template>

              <template v-slot:item.sumWithDiscount="{ item }">{{
                (item.quantity *
                  item.price *
                  (1 - (item.discount + item.discountPayment) / 100))
                  | toDecimal
              }}</template>

              <template v-slot:item.sum="{ item }">{{
                (item.quantity * item.price) | toDecimal
              }}</template>

              <template v-slot:item.discount="{ item }"
                >{{ item.discount }}%

                <v-spacer></v-spacer>
                <v-badge
                  v-if="item.discountChanged"
                  color="warning"
                  bordered
                  :content="`${item.oldDiscount}`"
                ></v-badge>
                <v-spacer></v-spacer>
                <code v-if="item.isntDiscount">без скидки</code></template
              >

              <template v-slot:item.goods.dosageForm.name="{ item }">
                {{ item.goods.dosageForm.name }}/{{ item.goods.dose.name }}/{{ item.goods.number }}
              </template>

              <template v-slot:footer>
                <v-divider></v-divider>
                <v-layout justify-end>
                  <v-chip class="ma-2" label justify-end>
                    {{
                      stringValues.orderTotalWithDiscount[
                        currentLanguage.language
                      ]
                    }}: 
                    <b>
                      {{
                      item.orderDetails
                        .map(
                          (x) => x.quantity * x.price * (1 - x.discount / 100)
                        )
                        .reduce(function (previousValue, currentValue) {
                          return previousValue + currentValue;
                        }) | toDecimal
                    }}
                    </b>
                  </v-chip>

                  <v-chip class="ma-2" label justify-end>
                    {{
                      stringValues.orderTotalWithoutDiscount[
                        currentLanguage.language
                      ]
                    }}:
                    <b>
                      {{
                      item.orderDetails
                        .map((x) => x.quantity * x.price)
                        .reduce(function (previousValue, currentValue) {
                          return previousValue + currentValue;
                        }) | toDecimal
                    }}
                    </b>
                  </v-chip>
                </v-layout>
              </template>
            </v-data-table>
          </v-col>

          <!-- order operation -->
          <v-col cols="1" class="text-left">
            <v-card
              elevation="0"
              style="position: -webkit-sticky; position: sticky; top: 60px"
              class="pt-4"
            >
              <div class="mb-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      small
                      @click="
                        currentOrder = item;
                        dialog.orderSend = true;
                      "
                      :loading="loading.orderSend && item.id == currentOrder.id"
                      :disabled="
                        loading.orderSend && item.id == currentOrder.id
                      "
                    >
                      <v-icon>mdi-send</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    stringValues.sendOrder[currentLanguage.language]
                  }}</span>
                </v-tooltip>
              </div>
              <div class="mb-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      small
                      @click="
                       UnloadExcel(item.id);
                       currentOrder.id = item.id;
                       loading.downloadFile = true;
                      "
                      :loading="loading.downloadFile && item.id == currentOrder.id"
                      :disabled="
                        loading.downloadFile && item.id == currentOrder.id
                      "
                    >
                      <v-icon>mdi-file-excel</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Выгрузить в excel
                  </span>
                </v-tooltip>
              </div>
              <div class="mb-1">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      fab
                      small
                      @click="openDeleteDialog(
                        'Удаление заказа',
                        `Вы действительно хотите удалить заказ №${item.id}?`,
                        DeleteOrder,
                        item.id
                      )"
                      :loading="
                        loading.deleteOrder && item.id == currentOrder.id
                      "
                      :disabled="
                        loading.deleteOrder && item.id == currentOrder.id
                      "
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    stringValues.deleteOrder[currentLanguage.language]
                  }}</span>
                </v-tooltip>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-row>
        <v-col cols="12" md="4" offset-md="4">
          <v-card
            v-show="getOrderFromAPI"
            width="500"
            elevation="0"
            class="text-center"
          >
            <v-card-text class="text-center">
              Подождите, пожалуйста пока загружаются заказы
              <v-progress-linear
                indeterminate
                color="primary"
                class="mb-0"
                height="10"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>

    <!-- Окно отправки заказов -->
    <v-dialog v-model="dialog.orderSend" persistent max-width="1000" scrollable>
      <OrderSend
        :order="currentOrder"
        @onCloseDialog="dialog.orderSend = false"
      ></OrderSend>
    </v-dialog>

    <!-- Окно поделится заказом в чате -->
    <v-dialog v-model="dialog.shareOnChat" persistent max-width="800">
      <Share
        :order="currentOrder"
        @onCloseDialog="dialog.shareOnChat = false"
      ></Share>
    </v-dialog>

    <!-- Окно просмотра заказа в полном экране -->
    <v-dialog v-model="dialog.orderFullScreen" hide-overlay fullscreen>
      <OrderFullScreen
        :orderFullScreen="currentOrder"
        @onCloseDialog="dialog.orderFullScreen = false"
      ></OrderFullScreen>
    </v-dialog>

    <DeleteConfirmDialog
      v-model="dialog.deleteDialog"
      :title="deleteDialogContent.title"
      :message="deleteDialogContent.message"

      @confirm="confirmDelete"
      @cancel="clearDeleteState"
    />

    <!-- ZERO.kz -->
    <span id="_zero_75287">
      <noscript>
        <a href="https://zero.kz/?s=75287" target="_blank">
          <img src="https://c.zero.kz/z.png?u=75287" width="88" height="31" alt="ZERO.kz" />
        </a>
      </noscript>
    </span>
    <!-- End ZERO.kz -->
  </v-row>

</template>
<script>
export default {
  props: {
    userId: {
      type: [String, Number],
      default: null,
    },
    centralizedOrder: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    goodsPrices: [],
    quantityRules: (v) => v > 0 || "не должно быть меньше 1",
    modelState: {},

    loading: {
      deleteOrder: false,
      deleteOrderByUser: false,
      orderSend: false,
      downloadFile: false,
    },

    dialog: {
      orderFullScreen: false,
      orderSend: false,
      shareOnChat: false,
      deleteDialog: false,
    },

    deleteDialogContent: {
      title: "",
      message: "",

      action: null,
      payload: null,
    },

    currentOrder: {
      // id: -1,
      // filial: {
      //   name: "",
      // },
      // createdDate: "",
      // comment: "",
    },
    headers: {
      RU: [
        // { text: "", value: "id" },
        { text: '№', value: 'index' },
        { text: "Название", value: "goods.fullName" },
        { text: "Форма", value: "goods.dosageForm.name" },
        //{ text: "Номер", value: "goods.number" },
        { text: "Кол-во", value: "quantity" },
        { text: "Цена со скидкой", value: "priceWithDiscount" },
        { text: "Цена без скидки", value: "price" },
        { text: "МРЦ", value: "goods.priceLimitation.retail" },
        { text: "МОЦ", value: "goods.priceLimitation.trade"},
        { text: "Сумма со скидкой", value: "sumWithDiscount" },
        { text: "Сумма без скидки", value: "sum" },
        { text: "Скидка", value: "discount" },
        { text: "Срок годности", value: "shelfLife" },
        { text: "Остатки", value: "stored" }
      ],
      KZ: [
        { text: '№', value: 'index' },
        { text: "Атауы", value: "goods.fullName" },
        { text: "Нысаны", value: "goods.dosageForm.name" },
        //{ text: "Тапсырыс", value: "goods.number" },
        { text: "Саны", value: "quantity" },
        { text: "Жеңілдікпен бағасы", value: "priceWithDiscount" },
        { text: "Цена без скидки", value: "price" },
        { text: "ЕББ", value: "goods.priceLimitation.retail" },
        { text: "МОЦ", value: "goods.priceLimitation.trade"},
        { text: "Сумма со скидкой", value: "sumWithDiscount" },
        { text: "Сумма без скидки", value: "sum" },
        { text: "Жеңілдік", value: "discount" },
        { text: "Жарамдылық мерзімі", value: "shelfLife" },
        { text: "Остатки", value: "stored" }
      ],
    },
    paymentTypes: [],
    collapsedOrders: [],
  }),
  methods: {
    openDeleteDialog(title, message, action, payload = null) {
      this.deleteDialogContent.title = title;
      this.deleteDialogContent.message = message;

      this.deleteDialogContent.action = action;
      this.deleteDialogContent.payload = payload;

      this.dialog.deleteDialog = true;
    },
    async confirmDelete() {
      if (!this.deleteDialogContent.action) return;

      //his.deleteLoading = true;

      try {
        await this.deleteDialogContent.action(this.deleteDialogContent.payload);

        this.dialog.deleteDialog = false;

        this.clearDeleteState();
      } catch (error) {
        window.console.error(error);
      } finally {
        //this.dialog.deleteLoading = false;
      }
    },
    clearDeleteState() {
      this.deleteDialogContent.action = null;
      this.deleteDialogContent.payload = null;

      this.deleteDialogContent.title = "";
      this.deleteDialogContent.message = "";
    },

    getRowClass(orderDetail) {
      return {
        'red-row': orderDetail.isInPrice === false, 
        'duplicate': orderDetail.isDuplicate === true 
      };
    },
    async UnloadExcel(orderId) {
      this.$store
        .dispatch("DOWNLOAD_ORDER_IN_EXECEL", orderId)
        .then(() => {
          this.loading.downloadFile = false;
        })
        .catch((error) => {
          window.console.log(error);
          this.loading.downloadFile = false;
        });
    },
    IsMinPrice(item) {
      if (item.minPrice) {
        const discounted = Number(
          (item.price - (item.price * item.discount) / 100).toFixed(2)
        );
        return discounted <= item.minPrice.toFixed(2);
      }
      return true;
    },
    ParseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month?.padStart(2, "0")}-${day?.padStart(2, "0")}`;
    },
    NotSelectedDetails(details) {
      if (details.length == 0) {
        let Snackbar = {
          text: "Выберите позиции",
          timeout: 3000,
          color: "warning",
          show: true,
        };
        this.$store.commit("SET_SNACKBAR", Snackbar);
        return true;
      }
    },
    CkeckOrderDetails(selectedDetails, orderId) {
      let orderIndex = this.orders.findIndex(x => x.id == orderId);

      let updatedOrder = {
        ...this.orders[orderIndex],
        orderDetails:  this.orders[orderIndex].orderDetails.map(x => ({
          ...x,
          isDuplicate: selectedDetails.some(y =>
            y.goodsId === x.goodsId &&
            y.price === x.price &&
            y.shelfLife === x.shelfLife &&
            y.batch === x.batch
          )
        }))
      };

      let hasDuplicates = updatedOrder.orderDetails.some(od => od.isDuplicate);

      if (hasDuplicates) {
        this.$store.commit('SET_UPDATE_ORDER_DETAILS', {updatedOrder, orderId});
        let Snackbar = {
            text: `В заказе уже имеется даннная позиция!`,
            timeout: 5000,
            color: "warning",
            show: true,
          };
        this.$store.commit("SET_SNACKBAR", Snackbar);
        return true;
      }
    },
    MoveDetailsToOrder(selectedDetails, orderId) {
      if (this.NotSelectedDetails(selectedDetails)) return;

      if (this.CkeckOrderDetails(selectedDetails, orderId)) return;

      let payload = {
        toOrderId: orderId,
        details: selectedDetails,
      };

      this.$store
        .dispatch("MOVE_DETAILS_TO_ORDER", payload)
        .then(() => {})
        .catch((error) => {
          window.console.log(error);
        });
    },
    MoveDetailsToStorage(details, toStorageId) {
      if (this.NotSelectedDetails(details)) return;
      let payload = {
        toStorageId,
        details,
      };

      this.$store
        .dispatch("MOVE_DETAILS_TO_STORAGE", payload)
        .then(() => {
          let Snackbar = {
            text: "Товар добавлен в хранилище!",
            timeout: 3000,
            color: "success",
            show: true,
          };

          this.$store.dispatch(
            "SET_DELETE_DETAILS_FROM_STORAGE",
            payload.details
          );
          this.$store.commit("SET_SNACKBAR", Snackbar);
        })
        .catch((error) => {
          window.console.log(error);
          let Snackbar = {
            text: "Ошибка при добавлении товара в хранилище!",
            timeout: 3000,
            color: "warning",
            show: true,
          };
          this.$store.commit("SET_SNACKBAR", Snackbar);
        });
    },
    SaveQuantity(detail) {
      let UpdatedDetail = {
        Id: detail.id,
        OrderId: detail.orderId,
        GoodsId: detail.goodsId,
        Batch: detail.batch,
        Quantity: detail.quantity,
        Discount: detail.discount,
        Price: detail.price,
        DistributorGoodsId: detail.distributorGoodsId,
      };

      this.$store
        .dispatch("UPDATE_DETAIL", UpdatedDetail)
        .then((response) => {
          if (response && response.status == 7) {
            detail.quantity = response.items[0].quantity;
          }
        })
        .catch((error) => {
          window.console.log(error);
          // if (error.response.data.errors) {
          //   this.modelState = error.response.data.errors;
          // }
          // this.error = true;
        });
    },
    CancelQuantity() {
      window.console.log("cancel");
    },
    OpenQuantity() {
      // this.modelState = {};
      window.console.log("open");
    },
    CloseQuantity() {
      window.console.log("close");
    },
    DeleteOrder(id) {
      this.currentOrder.id = id;
      this.loading.deleteOrder = true;

      return this.$store
        .dispatch("DELETE_ORDER", id)
        .then(() => {
          this.loading.deleteOrder = false;
        })
        .catch(() => {
          this.loading.deleteOrder = false;
        });
    },
    DeleteOrderByUser() {
      const userId = this.currentUserId;
      if (!userId) return Promise.resolve();

      this.loading.deleteOrderByUser = true;

      return this.$store
        .dispatch("DELETE_ORDER_BY_USER", userId)
        .then(() => {
          this.loading.deleteOrderByUser = false;
          window.location.reload();
        })
        .catch(() => {
          this.loading.deleteOrderByUser = false;
        });
    },
    DeleteDetails(details) {
      if (this.NotSelectedDetails(details)) return Promise.resolve();

      var tempDetails = details.filter(
        (x) => x.isMainWorkloadGroup == false || x.isMainPromoGroup == false
      );

      if (tempDetails.length > 0) {
        let Snackbar = {
          text: "Нельзя удалять акционные/нагрузочные позиции!",
          timeout: 3000,
          color: "warning",
          show: true,
        };
        this.$store.commit("SET_SNACKBAR", Snackbar);

        return Promise.resolve();
      } else {
        return this.$store
          .dispatch("DELETE_DETAILS", details)
          .then(() => {})
          .catch(() => {});
      }
    },
    SplitDetails(details) {
      if (this.NotSelectedDetails(details)) return;

      this.$store
        .dispatch("SPLIT_DETAILS", details)
        .then(() => {})
        .catch(() => {});
    },
    GetPriceByGoodsId(goods, filialId) {
      this.goodsPrices = [];
      let payload = {
        goodsId: goods.goodsId,
        goods: goods,
      };

      this.$store
        .dispatch("PRICE_BY_GOODS_ID", payload)
        .then(() => {
          this.goodsPrices = this.$store.getters.PRICE_BY_GOODS_ID.prices
            .filter((x) => x.filialId !== filialId)
            .sort(function (a, b) {
              return (
                a.goodsPriceWithUserDiscount - b.goodsPriceWithUserDiscount
              );
            });
        })
        .catch(() => {});
    },
    GetPriceByGoodsIdAndCityId(item) {
      window.console.log("getpricebygoodsid", item);
      this.goodsPrices = [];
      let cityId = this.$store.getters.ORDERS.filter(
        (x) => x.id == item.orderId
      )[0]?.filial?.cityId;
      let payload = {
        goodsId: item.goodsId,
        goods: item,
      };
      if (cityId) {
        this.$store
          .dispatch("PRICE_BY_GOODS_ID", payload)
          .then(() => {
            this.goodsPrices = this.$store.getters.PRICE_BY_GOODS_ID.prices
              .filter((x) => x.filial.cityId == cityId)
              .sort(function (a, b) {
                return (
                  a.goodsPriceWithUserDiscount - b.goodsPriceWithUserDiscount
                );
              });
          })
          .catch(() => {});
      }
    },
    SelectFilial(value, item) {
      this.$store.dispatch("GET_RE_ORDER_DETAIL", {
        detailId: item.id,
        orderId: item.orderId,
      });
      let OrderDialog = {
        goodsQuantity: item.quantity,
        show: true,
        price: Object.assign({}, value),
      };
      this.$store.commit("SET_ORDER_DIALOG", OrderDialog);
    },

    async GetPaymentTypes() {
      await this.$store
        .dispatch("GET_ALL_PAYMENT_TYPES")
        .then((response) => {
          this.paymentTypes = response;
        })
        .catch(() => {});
    },

    // async CheckInPriceDetails(order) {
    //   this.loading.orderSend = true;
    //   try {
    //     order.selectedDetails = [];
    //     const response = await this.$store.dispatch('CHECK_IN_PRICE_DETAILS', order);
        
    //     if (response.orderDetails.find(x => !x.isInPrice)){
    //       let Snackbar = {
    //         text: "Проверьте выделенные позиции красным цветом, которые означают отсутствие товара у поставщика.",
    //         timeout: 12000,
    //         color: "warning",
    //         linkText: "",
    //         show: true,
    //       };

    //       this.$store.commit('SET_SNACKBAR', Snackbar);
    //       this.$store.commit('SET_CHECK_IN_PRICE_DETAILS', response);
    //     } else {
    //       this.dialog.orderSend = true;
    //     }
    //   } catch (error) {
    //     window.console.error('Ошибка при проверке заказа:', error);
    //   }
    //   this.loading.orderSend = false;
    // },

    collapseOrder(item) {
      var index = this.collapsedOrders.indexOf(item);

      if (index === -1) this.collapsedOrders.push(item);
      else this.collapsedOrders.splice(index, 1);
    },
    collapseAllOrders() {
      let orderIds = this.orders.map((x) => x.id);
      this.collapsedOrders = orderIds;
    },
    expandAllOrders() {
      this.collapsedOrders = [];
    },
  },
  async created() {
    await this.GetPaymentTypes();
  },
  computed: {
    stringValues: {
      get() {
        return this.$store.getters.STRING_VALUES;
      },
    },
    currentLanguage: {
      get() {
        return this.$store.getters.CURRENT_LANG;
      },
    },
    getOrderFromAPI: {
      get: function () {
        return this.$store.getters.GET_ORDER_FROM_API;
      },
      set: function (value) {
        this.$store.commit("SET_ORDER_FROM_API", value);
      },
    },
    orders: {
      get: function () {
        return this.$store.getters.ORDERS;
      },
    },
    orderNav: {
      get: function () {
        return this.$store.getters.ORDER_NAVIGATION;
      },
      set: function (orderIndex) {
        this.$store.commit("SET_ORDER_NAVIGATION", orderIndex);
      },
    },
    ordersNav: {
      get: function () {
        let orderNav = this.$store.getters.ORDER_NAVIGATION;
        if (orderNav == 0) return this.$store.getters.ORDERS;
        return this.$store.getters.ORDERS.slice(orderNav - 1, orderNav);
      },
    },
    storages: {
      get: function () {
        return this.$store.getters.ACCESS_STORAGES;
      },
    },
    ordersTotalSum: {
      get: function () {
        let orders = this.$store.getters.ORDERS;
        let ordersSum = 0;
        orders.forEach((item) => {
          ordersSum += item.orderDetails
            .map((x) => x.quantity * x.price * (1 - x.discount / 100))
            .reduce(function (previousValue, currentValue) {
              return previousValue + currentValue;
            });
        });
        return ordersSum;
      },
    },
    currentUserId() {
      if (this.userId) return this.userId;

      const PHC_user = JSON.parse(localStorage.getItem("PHC_user"));
      return PHC_user?.id || null;
    },
    ordersForCurrentUser() {
    return this.$store.state.orders.filter(
      order => order.PHC_user?.id === this.currentUserId
    );
  }
  },
  mounted() {
    // Создаём массив, если ещё нет
    window._zero_kz_ = window._zero_kz_ || [];
    window._zero_kz_.push(['id', 75287]);
    window._zero_kz_.push(['type', 1]);
    // window._zero_kz_.push(['url_watcher', 200]);

    // Добавляем внешний скрипт
    const script = document.createElement("script");
    script.src =
      (document.location.protocol === "http:" ? "http:" : "https:") +
      "//c.zero.kz/z.js";
    script.async = true;

    document.body.appendChild(script);

  //   if (!this.userId && this.currentUserId) {
  //   this.$store.dispatch("ORDERS_BY_USER", this.currentUserId);
  // }
  },
};
</script>
<style lang="css">
.orderList tbody tr:nth-of-type(odd) {
  background-color: #dbe7e8;
}
.custom-subheader {
  line-height: 12px; 
  padding: 1px;
  height: 38px;
}
tr.v-data-table__selected {
    background-color: #538c92 !important;
    color: black !important;
}
.red-row {
  background-color: #ff000033 !important;
}
.duplicate {
  background-color: rgba(255, 165, 0, 0.3) !important; /* Оранжевый фон */
}
#_zero_75287{
  display: none;
}
</style>